import { useContext, useState } from 'react'
import StarRoundedIcon from '@mui/icons-material/StarRounded'
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'

import ConversationApi from '../../../../../api/conversations.api'
import { ToastContext } from '../../../../../context/ToastContext'
import { parseDate } from '../../../../utils/date'

import DeleteConversationModal from './DeleteConversationModal'
import EditConversationModal from './EditConversationModal'

const ConversationRow = ({ conversation, handleSelectConversation, setConversations }) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [openEditModal, setOpenEditModal] = useState(false)
  const { showToast } = useContext(ToastContext)

  const changeFavorite = async () => {
    const nextFavoriteValue = !conversation.isFavorite

    setConversations((conversations) => conversations.map((c) => {
      if (c.id === conversation.id) {
        return { ...c, isFavorite: nextFavoriteValue }
      }

      return c
    }))

    try {
      await ConversationApi.updateConversation(
        conversation.id,
        { isFavorite: nextFavoriteValue }
      )
    } catch (error) {
      const hasServerResponse = Boolean(error?.response)

      if (hasServerResponse) {
        setConversations((conversations) => conversations.map((c) => {
          if (c.id === conversation.id) {
            return { ...c, isFavorite: conversation.isFavorite }
          }

          return c
        }))
        showToast('error', 'No se pudo actualizar el destacado. Intenta nuevamente.')
        return
      }

      showToast('error', 'Sin conexión: el cambio quedó visible en pantalla, pero no se pudo sincronizar con el servidor.')
    }
  }


  return (
    <div className="rounded-2xl border border-primary/10 bg-white/90 px-4 py-4 shadow-[0_14px_28px_rgba(15,23,42,0.06)] transition-all hover:-translate-y-0.5 hover:border-primary/20 hover:shadow-[0_18px_34px_rgba(15,23,42,0.08)] sm:px-5">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className='min-w-0 flex-1'>
          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-primary/70 sm:text-xs">
            Última interacción
          </p>
          <p className='mt-1 text-xs text-muted sm:text-sm'>
            {parseDate(conversation.lastInteraction)}
          </p>
          <button
            type='button'
            className="mt-3 w-full min-w-0 text-left sm:w-auto"
            onClick={() => handleSelectConversation(conversation)}
          >
            <h2 className="break-words text-base font-semibold text-text transition-colors hover:text-primary sm:text-xl">
              {conversation.name}
            </h2>
          </button>
        </div>
        <div className='flex flex-wrap items-center justify-end gap-2 self-end sm:self-start'>
          <button
            type='button'
            title={conversation.isFavorite ? 'Quitar de destacados' : 'Marcar como destacado'}
            aria-label={conversation.isFavorite ? 'Quitar de destacados' : 'Marcar como destacado'}
            className='inline-flex h-11 min-w-[96px] items-center justify-center gap-2 rounded-xl border border-primary/10 bg-white px-3 text-amber-500 shadow-[0_8px_18px_rgba(15,23,42,0.05)] transition-all hover:-translate-y-0.5 hover:border-amber-200 hover:bg-amber-50'
            onClick={() => changeFavorite()}
          >
            {conversation.isFavorite
              ? <StarRoundedIcon sx={{ fontSize: 22 }} className="shrink-0" />
              : <StarBorderRoundedIcon sx={{ fontSize: 22 }} className="shrink-0" />
            }
            <span className='text-xs font-semibold text-text'>
              {conversation.isFavorite ? 'Destacado' : 'Destacar'}
            </span>
          </button>
          <button
            type='button'
            title='Editar nombre del chat'
            aria-label='Editar nombre del chat'
            className='inline-flex h-11 min-w-[88px] items-center justify-center gap-2 rounded-xl border border-primary/10 bg-white px-3 text-primary shadow-[0_8px_18px_rgba(15,23,42,0.05)] transition-all hover:-translate-y-0.5 hover:border-primary/20 hover:bg-primary/[0.04]'
            onClick={() => setOpenEditModal(true)}
          >
            <EditOutlinedIcon sx={{ fontSize: 20 }} className="shrink-0"/>
            <span className='text-xs font-semibold text-text'>Editar</span>
          </button>
          <button
            type='button'
            title='Eliminar chat'
            aria-label='Eliminar chat'
            className='inline-flex h-11 min-w-[94px] items-center justify-center gap-2 rounded-xl border border-primary/10 bg-white px-3 text-danger shadow-[0_8px_18px_rgba(15,23,42,0.05)] transition-all hover:-translate-y-0.5 hover:border-danger/20 hover:bg-danger/[0.04]'
            onClick={() => setOpenDeleteModal(true)}
          >
            <DeleteOutlineRoundedIcon sx={{ fontSize: 20 }} className="shrink-0"/>
            <span className='text-xs font-semibold text-text'>Eliminar</span>
          </button>
        </div>
      </div>
      <EditConversationModal
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        conversation={conversation}
        setConversations={setConversations}
      />
      <DeleteConversationModal
        open={openDeleteModal}
        onClose={() => setOpenDeleteModal(false)}
        conversation={conversation}
        setConversations={setConversations}
      />
    </div>
  )
}

export default ConversationRow
